import { mapActions, mapGetters, mapMutations } from 'vuex'
import { MutationTypes } from '~/store/branches/mutation-types'

export default {
  computed: {
    ...mapGetters({
      branches: 'branches/getBranches',
      branchesWithDistance: 'branches/getBranchesWithDistance',
      sortedBranches: 'branches/sortedBranches',
      searchedList: 'branches/searchedList',
    }),
  },
  methods: {
    ...mapActions({
      fetchBranchWithDistance: 'branches/fetchBranchWithDistance',
    }),
    ...mapMutations({
      setBranches: 'branches/' + MutationTypes.MODIFY_BRANCHES,
      setBranchesWithDistance:
        'branches/' + MutationTypes.MODIFY_BRANCHES_WITH_DISTANCE,
    }),
  },
}
